import axios from '../../axios';
import { ADD_JOURNAL_VOUCHER, GET_JOURNAL_VOUCHER, UPDATE_JOURNAL_VOUCHER, DELETE_JOURNAL_VOUCHER } from '../types';
import { toast } from 'react-toastify';

// In your actions file (where getJournalVoucher is defined)
export const getJournalVoucher = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/voucher/allJV', { params });

      if (res.data.code === 1) {

         dispatch({
            type: GET_JOURNAL_VOUCHER,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
               totalCount: res.data.totalCount,
            },
         });
         return res.data.data;
      }
   } catch (err) {
      console.error('Error:', err);
   }
};

export const addJournalVoucher = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/voucher/add-journal-voucher', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_JOURNAL_VOUCHER, payload: res.data.data });

         setTimeout(() => {
            toast.success('Journal Voucher updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateJournalVoucher = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/voucher/edit-journal-voucher`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_JOURNAL_VOUCHER, payload: res.data.data });

         setTimeout(() => {
            toast.success('Voucher updated successfully!');
         }, 1000);
      }

      if (res.data.code === 2) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.warn(err.response.data?.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

// export const deleteJournalVoucher = (id) => async (dispatch) => {
//    try {
//       if (!id) {
//          toast.error('Please select any record');
//          return false;
//       }
//       const res = await axios.post(`/voucher/delete-journal-voucher/${id}`);
//       if (res.data.code === 1) {
//          dispatch({ type: DELETE_JOURNAL_VOUCHER, payload: { id } });
//       }
//    } catch (err) {
//       if (err.response.data.errors[0].message) {
//          toast.error(err.response.data.errors[0].message);
//       }
//    }
// };

export const deleteJournalVoucher = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/voucher/delete-journal-voucher`, formData);

      if (res.data.code === 1) {
         dispatch({ type: DELETE_JOURNAL_VOUCHER, payload: formData });

         setTimeout(() => {
            toast.success('Journal Voucher Delete successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};
